import React from 'react';
import styled from 'styled-components';
import LoaderSmall from 'components/loaders/LoaderSmall';

const StyledButtonLoader = styled.span`
  margin-left: 10px;
`;

const ButtonLoader = () => {
  return (
    <StyledButtonLoader>
      <LoaderSmall width={28} height={28} />
    </StyledButtonLoader>
  );
};

export default ButtonLoader;



// WEBPACK FOOTER //
// ./src/components/common/ButtonLoader/ButtonLoader.jsx